var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.videerror == true
    ? _c("b-row", [
        _c(
          "div",
          {
            staticClass:
              "fixed-top d-flex align-items-center justify-content-center",
            staticStyle: { bottom: "0", "overflow-y": "auto" },
          },
          [
            _c(
              "b-card",
              {
                staticClass: "shadow",
                attrs: { "bg-variant": "#ffffff", "text-variant": "dark" },
              },
              [_c("b-card-text", [_vm._v(" " + _vm._s(_vm.message) + " ")])],
              1
            ),
          ],
          1
        ),
      ])
    : _vm.isAuthenticated == false
    ? _c("Verification", {
        attrs: {
          education: _vm.link,
          DOBPresent: _vm.patientDOB !== undefined,
        },
        on: { "valid-patient": _vm.validatePatient },
      })
    : _vm.isAuthenticated == true
    ? _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-card-title", { staticClass: "pb-3 pt-2" }, [
            _vm._v(_vm._s(_vm.currentVideo.videoName)),
          ]),
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c("b-col", {
                attrs: { cols: "12", id: _vm.currentVideo.videoLink },
              }),
              _c(
                "b-col",
                { staticClass: "mt-2 center-block", attrs: { cols: "12" } },
                [_vm._v(" " + _vm._s(_vm.currentVideo.videoDescription) + " ")]
              ),
              this.showAck
                ? _c(
                    "div",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "mt-2 text-center",
                          attrs: { cols: "12" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                "By clicking this button, I acknowledge that I have watched the video in its entirety"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "mt-2 text-center",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: _vm.isFinished,
                                variant: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.acknowledge()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.buttonText))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }